import type { ComponentType } from 'react';
import { InputType } from 'generated/graphql';
import { AutocompleteField } from './fields/AutocompleteField';
import { ButtonUrlField } from './fields/ButtonUrlField';
import { CalculatedFieldWrapper } from './fields/CalculatedFieldWrapper';
import { CheckboxField } from './fields/CheckboxField';
import { CurrencyField } from './fields/CurrencyField';
import { DateField } from './fields/DateField';
import { DefaultTextField } from './fields/DefaultTextField';
import { FileImageUploadField } from './fields/FileImageUploadField';
import { InfoBarField } from './fields/InfoBarField';
import { MultiToggleField } from './fields/MultiToggleField';
import { MultilineField } from './fields/MultilineField';
import { MultiselectField } from './fields/MultiselectField';
import { NumberField } from './fields/NumberField';
import { NumberStepperField } from './fields/NumberStepperField';
import { PasswordField } from './fields/PasswordField';
import { PercentageField } from './fields/PercentageField';
import { ReadonlyField } from './fields/ReadonlyField';
import { SearchField } from './fields/SearchField';
import { SelectField } from './fields/SelectField';
import { SliderField } from './fields/SliderField';
import { SwitchField } from './fields/SwitchField';
import type { FieldRendererProps } from './types';

type FieldRenderer = ComponentType<FieldRendererProps>;

export const FIELD_RENDERERS: Partial<Record<InputType, FieldRenderer>> = {
  [InputType.Checkbox]: CheckboxField,
  [InputType.Switch]: SwitchField,
  [InputType.Multitoggle]: MultiToggleField,
  [InputType.Select]: SelectField,
  [InputType.Currency]: CurrencyField,
  [InputType.Multiselect]: MultiselectField,
  [InputType.Autocomplete]: AutocompleteField,
  [InputType.Date]: DateField,
  [InputType.Images]: FileImageUploadField,
  [InputType.Files]: FileImageUploadField,
  [InputType.Multiline]: MultilineField,
  [InputType.Number]: NumberField,
  [InputType.Calculated]: CalculatedFieldWrapper,
  [InputType.CalculatedCurrency]: CalculatedFieldWrapper,
  [InputType.Slider]: SliderField,
  [InputType.Percentage]: PercentageField,
  [InputType.Password]: PasswordField,
  [InputType.Numberstepper]: NumberStepperField,
  [InputType.Search]: SearchField,
  [InputType.ButtonUrl]: ButtonUrlField,
  [InputType.Infobar]: InfoBarField,
  [InputType.Readonly]: ReadonlyField,
};

export function getFieldRenderer(type: InputType): FieldRenderer {
  return FIELD_RENDERERS[type] ?? DefaultTextField;
}
